var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 160,
    viewBox: "0 0 16 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8499 0.914307H1.47095V159.581H14.8499V0.914307Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06311 0.849243L9.06313 156.751",
    stroke: "white",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1294 158.04H2.19141",
    stroke: "white",
    strokeWidth: 3.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1294 2.59924H2.19141",
    stroke: "white",
    strokeWidth: 3.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9104 2.02197L8.91041 158.091",
    stroke: "black",
    strokeWidth: 2.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7561 158.379H3.95605",
    stroke: "black",
    strokeWidth: 2.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7561 2.77197H3.95605",
    stroke: "black",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.ab7be837a76c4b28c41c9a0cd057dc44.svg";
export { ForwardRef as ReactComponent };